import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Permission yang boleh dimiliki akun "kasir-saja". Akun yang punya cashpay.use dan hanya
 * permission-permission ini dianggap kasir: setelah login langsung ke layar kasir, dan tidak
 * dimasukkan ke dashboard.
 */
export const CASHIER_ONLY_PERMISSIONS: readonly string[] = [
  'cashpay.use',
  'student.read',
  'student.update',
  'payment.create',
  'periode.read',
];

export const CASHIER_ROUTE = '/cashier';
export const DASHBOARD_ROUTE = '/dashboard';

@Injectable({ providedIn: 'root' })
export class LandingRouteService {
  constructor(private auth: AuthService) {}

  /**
   * Kasir-saja: punya cashpay.use, bukan admin, dan semua permission-nya termasuk himpunan kasir.
   */
  isCashierOnly(): boolean {
    const permissions = this.auth.permissions ?? [];

    if (permissions.includes('core.admin') || this.auth.user?.access === 'ADMIN') {
      return false;
    }

    return (
      permissions.includes('cashpay.use') &&
      permissions.every((permission) => CASHIER_ONLY_PERMISSIONS.includes(permission))
    );
  }

  /** Halaman awal setelah login atau saat membuka alamat akar. */
  homeRoute(): string {
    return this.isCashierOnly() ? CASHIER_ROUTE : DASHBOARD_ROUTE;
  }
}
